module.exports = __webpack_public_path__ + "img/scan.2fd70206.png";